import { FC, ReactNode } from 'react'
import { Icon, Text } from '@/ui'
import { mtc, TypographyStyles } from '@/styles'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface Props {
  text: string
  prominentText: ReactNode
  icon?: IconProp
  textColor?: string
  className?: string
}

export const DeadlineLabel: FC<Props> = ({
  text,
  prominentText,
  textColor,
  icon,
  className,
  ...rest
}) => (
  <Text
    variant={TypographyStyles.BODY_SM}
    className={mtc(
      textColor ? textColor : 'text-orange-500',
      `flex flex-row inline-block ${className}`
    )}
    {...rest}
  >
    <span className="flex flex-row items-center">
      {icon && <Icon icon={icon} className="mr-2 block" />}
      {text} <span className="font-semibold ml-1">{prominentText}</span>
    </span>
  </Text>
)
